import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import InputForm from '../../../../InputT';
import Amortissement from '../../../../../Functions/Traitement/Amortissement';
import Pret from '../../../../../Models/Pret';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
//import "../../Assets/Styles/StyleForm.css";



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const Tab5= (props: { form?: any ,data:any[]}) => {
  // USER SESSION
  const auth = useAuthUser()
 

  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState([])


  const columns: ColumnsType<any> = [
    {
      title: 'N° écheance',
      dataIndex: 'NumeroEch',
    },
    {
      title: 'Date Echéance',
      dataIndex: 'DateEcheance',
    },
    {
      title: 'Capital Initial',
      dataIndex: 'CapitalInitial',
    },
    {
      title: 'Amortissement',
      dataIndex: 'CapitalRembourse',
    },
    {
      title: 'Capital Restant',
      dataIndex: 'CapitalRestant',
    }
   
  ];

  //  : number,
  //  : number,
  // montantTA : number,
  // echeancierPlusTA : number,
  //  : number,
  // echeancierTot : number,
  //  : Date

  useEffect(() => {
    forceUpdate({});
  }, []);

  

  return (

    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className='border' height={"60%"} width={"85%"} position={"absolute"}>
          <div className='clientP'>
            <div >
              <Box position={"relative"} display={"flex"} fontStyle="inherit" width={"99%"} className='border-left tabElement'>
                <Spin spinning={loading}>
                  <Table size='small' style={{ width: 'auto' }} columns={columns} dataSource={props.data} scroll={{ y: 220, x: 10 }} pagination={false} />
                </Spin>
                <Box display={"flex"} width={"%"} marginTop={"5%"} fontStyle="inherit" className='border-left bordure1 tabElement2'>
                  <InputForm money notRequired disabled width={8} label='Montant' name='MontantDemande' type='number' error='mobile' />
                </Box>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Box>
      </div>
    </div>
  )
  
}
export default Tab5;